// extracted by mini-css-extract-plugin
export var dataCell = "_nj-2";
export var dataRow = "_nj-0";
export var headerRow = "_nj-1";